module.exports = __webpack_public_path__ + "static/media/talksCardBack.a240ac0c.svg";